import AXIOS from 'axios'

let instance = AXIOS.create({
    timeout: 8000,
    withCredentials: true,
    headers: { // 默认头部
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest'
    },
    transformRequest: [
        function (data) {
            return JSON.stringify({
                data: data
            })
        }
    ]
})

// 拦截器
instance.interceptors.response.use(
    response => {
        let resData = response.data

        if (+resData.result === 0) { // gateway接口
            if (resData.data.result === 0) {
                resData.data.retcode = resData.data.result
                resData.data.retmsg = resData.data.res_info
                return Promise.resolve(resData.data)
            } else {
                return Promise.reject(
                    resData['data']['res_info'] || '数据加载异常'
                );
            }
        } else { // 非gateway接口
            if (+resData.retcode === 0) {
                return Promise.resolve(resData)
            }
            return Promise.reject(resData['res_info'] || resData['retmsg'] || '数据加载异常')
        }
    },
    err => {
        return Promise.reject(err.message)
    }
);

export default instance